import React from 'react';
import OrangeCheckIcon from '@repo/ui/src/components/Icons/OrangeCheck';
import ExcludedIcon from '@repo/ui/src/components/Icons/ExcludedIcon';

interface Props {
  salesforceValue: string | boolean;
}
const Value = ({ salesforceValue }: Props) =>
  typeof salesforceValue === 'boolean' ? (
    salesforceValue ? (
      <OrangeCheckIcon />
    ) : (
      <ExcludedIcon />
    )
  ) : (
    <p className="tra-text-web-body-l">{salesforceValue}</p>
  );

export default Value;
